import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC, useState } from 'react';

import { Caret } from 'src/Icons';
import { Label, LabelProps } from 'src/StatusLabel/Label';
import { StatusIcon } from 'src/StatusLabel/StatusIcon';
import { StatusLabelMenu } from 'src/StatusLabel/StatusLabelMenu';
import { StatusLabelClassNames, StatusLabelStatus } from 'src/types';

export interface Action {
  label: string;
  onClick: () => void;
}
export interface StatusLabelProps {
  /**
   * The status icon's accessible name, in the page's language. Without one the
   * icon is decorative, which is right when the label text already says the state.
   */
  iconLabel?: string;
  label: LabelProps['label'];
  status: `${StatusLabelStatus}`;
  options?: {
    fullLabel?: string;
    additionalInfo?: string[];
    isClick?: boolean;
  };
  actions: Action[];
}

export const StatusLabel: FC<StatusLabelProps> = ({ iconLabel, label, status, options = {}, actions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickForClickLabel = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    return actions[0] && actions[0].onClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hasMenu = Boolean(Object.keys(options).length) || Boolean(actions.length);

  return (
    <>
      <Grid
        className={classNames(StatusLabelClassNames.ROOT, {
          [StatusLabelClassNames.ACTION]: status === StatusLabelStatus.ACTION,
          [StatusLabelClassNames.INCOMPLETE]: status === StatusLabelStatus.INCOMPLETE,
          [StatusLabelClassNames.IN_PROGRESS]: status === StatusLabelStatus.IN_PROGRESS,
          [StatusLabelClassNames.PARTNER]: status === StatusLabelStatus.PARTNER,
          [StatusLabelClassNames.SUCCESS]: status === StatusLabelStatus.SUCCESS,
          [StatusLabelClassNames.WARNING]: status === StatusLabelStatus.WARNING,
          [StatusLabelClassNames.HOVER_STATE]: hasMenu,
        })}
        onClick={options.isClick ? handleClickForClickLabel : handleClick}
        role="listitem"
      >
        <StatusIcon className={StatusLabelClassNames.STATUS_ICON} label={iconLabel} status={status} />
        <Label label={label} />
        {hasMenu && <Caret className={StatusLabelClassNames.ACTION_ICON} />}
      </Grid>
      {hasMenu && !options.isClick && (
        <StatusLabelMenu actions={actions} anchorEl={anchorEl} handleClose={handleClose} options={options} />
      )}
    </>
  );
};
